import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiError, hasLiveApi } from '@/api/client'
import { deleteBlockedIp, saveBlockedIp } from '@/api/map/blockedDevices'

export function useSaveBlockedDevice() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: async (input: { deviceId: string; comment?: string }) => {
      if (!hasLiveApi()) {
        throw new ApiError(503, 'Hierarchy API is not configured', null)
      }
      const deviceId = input.deviceId.trim()
      if (!deviceId) {
        throw new ApiError(400, 'Please provide a device id', null)
      }
      const res = await saveBlockedIp({
        deviceId,
        comment: input.comment?.trim() ?? '',
      })
      if (!res.value) {
        throw new ApiError(409, res.error || 'Unable to block device id', res)
      }
      return res
    },
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: ['blocked-devices'] })
    },
  })
}

export function useDeleteBlockedDevice() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: async (input: { id: string; deviceId?: string; comment?: string }) => {
      if (!hasLiveApi()) {
        throw new ApiError(503, 'Hierarchy API is not configured', null)
      }
      const id = input.id.trim()
      if (!id) {
        throw new ApiError(400, 'Unable to delete device id', null)
      }
      const res = await deleteBlockedIp({
        _id: id,
        deviceId: input.deviceId,
        comment: input.comment,
      })
      if (!res.value) {
        throw new ApiError(409, res.error || 'Unable to delete device id', res)
      }
      return res
    },
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: ['blocked-devices'] })
    },
  })
}
